'use strict';

import Constants from '../constants.js';
import ObjectAssign from 'object-assign';

const initialState = {
    hydrated: false,
    loading: false,
    error: undefined,
    errorMessage: '',
    hasError: {},
    help: {},
    fieldKeys: [],
    hostedFieldsInstance: undefined,
    invalidFieldKeys: {},
    cardType: undefined,
    cardNiceType: undefined

};
const reducer = function (state = initialState, action) {

    if (action.type === Constants.RESET_HOSTED_FIELDS) {

        return ObjectAssign({}, initialState );
    }

    if (action.type === Constants.CREATE_HOSTED_FIELDS) {

        return ObjectAssign({}, state, {
            loading : true,
            hydrated : false,
            error: undefined,
            errorMessage: '',
            fieldKeys: [],
            invalidFieldKeys: {}
        });

    }

    if (action.type === Constants.CREATE_HOSTED_FIELDS_RESULT) {

        if (!action.err ){
            return ObjectAssign({}, state, {
                loading: false,
                hydrated: true,
                error: undefined,
                hostedFieldsInstance: action.hostedFieldsInstance
            });
        }

        return ObjectAssign({}, state, {
            loading : false,
            hydrated : false,
            error: true,
            errorMessage: action.err.message,
            fieldKeys: [],
            invalidFieldKeys: {}
        });

    }

    if (action.type === Constants.CARD_CHANGE) {

        return ObjectAssign({}, state, {
            cardType: action.cardType,
            cardNiceType: action.cardNiceType
        });
    }

    if (action.type === Constants.VALIDITY_CHANGE) {
        //a good example https://codepen.io/braintree/pen/MyzXqG
        //but doing all of them make for green fields when
        //things are "potentially" correct what does it mean for a
        //name to be correct?  You should not get green for entering one letter
        //on the card name but when do you get greeen?
        const event = action.event;
        const field = event.fields[event.emittedBy];
        const id = field.container.id;
        const invalidFieldKeys = ObjectAssign({}, state.invalidFieldKeys);

        if (field.isValid) {

            delete invalidFieldKeys[id];
        }
        else if (field.isPotentiallyValid) {
            // Remove styling  from potentially valid fields
            delete invalidFieldKeys[id];
        }
        else {
            // Add helper text for an invalid card number
            if (event.emittedBy === 'number') {
                invalidFieldKeys[id] = { invalid: true, message: 'Invalid card number' };
            }
            else if (event.emittedBy === 'expirationDate') {
                invalidFieldKeys[id] = { invalid: true, message: 'Invalid card expiration date' };
            }
            else if (event.emittedBy === 'cardholderName') {
                invalidFieldKeys[id] = { invalid: true, message: 'Required' };
            }
        }

        return ObjectAssign({}, state, { invalidFieldKeys });

    }

    if (action.type === Constants.SUBMIT_HOSTED_FIELDS) {

        return ObjectAssign({}, state, {
            loading : false,
            hydrated : false,
            error: action.err,
            errorMessage: '',
            fieldKeys: [],
            invalidFieldKeys: {}
        });

    }

    if (action.type === Constants.SUBMIT_HOSTED_FIELDS_RESPONSE) {

        if ( !action.err) {
            return ObjectAssign({}, state, {
                loading: false,
                hydrated: true,
                error: undefined
            });
        }

        let errorMessage = '';
        let fieldKeys = [];
        let invalidFieldKeys = {};
        switch (action.err.code) {
            case 'HOSTED_FIELDS_FIELDS_EMPTY':
                // occurs when none of the fields are filled in
                errorMessage = 'Please fill out the entire form.';
                break;
            case 'HOSTED_FIELDS_FIELDS_INVALID':
                // occurs when certain fields do not pass client side validation
                if (action.err.message ){
                    errorMessage = action.err.message;
                } else  {
                    errorMessage = 'Some fields are invalid:';
                }
                fieldKeys = action.err.details.invalidFieldKeys;
                invalidFieldKeys = fieldKeys.reduce( (acc, fk) => {
                    acc[fk] = { invalid: true, message: 'invalid' };
                    return acc;
                }, {});

                // you can also programtically access the field containers for the invalid fields
                //tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
                //    fieldContainer.className = 'invalid';
                //});
                break;
            case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
                // occurs when:
                //   * the client token used for client authorization was generated
                //     with a customer ID and the fail on duplicate payment method
                //     option is set to true
                //   * the card being tokenized has previously been vaulted (with any customer)
                // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
                errorMessage = 'This payment method already exists in your vault.';
                break;
            case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
                // occurs when:
                //   * the client token used for client authorization was generated
                //     with a customer ID and the verify card option is set to true
                //     and you have credit card verification turned on in the Braintree
                //     control panel
                //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
                // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
                errorMessage = 'CVV did not pass verification';
                break;
            case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
                // occurs for any other tokenization error on the server
                errorMessage = 'Tokenization failed server side. Is the card valid?';
                break;
            case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
                // occurs when the Braintree gateway cannot be contacted
                errorMessage = 'Network error occurred when tokenizing.';
                break;
            default:
                errorMessage = 'Something bad happened!' +  action.err;
        }

        return ObjectAssign({}, state, {
            loading: false,
            hydrated: true,
            error : action.err,
            errorMessage,
            fieldKeys,
            invalidFieldKeys
        });
    }

    return state;
};


export default reducer;
